const config = {
  apiURL: 'https://ayurvedamarket.ru/utils/api',
};

export default config;